import { t } from "@/i18n-js/instance";
import type { ParticipantDisplayRole } from "@/react/types/Live/Participant";
import { PARTICIPANT_DISPLAY_ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";

interface RoleIconProps {
  role: ParticipantDisplayRole;
}

export const RoleIcon = ({ role }: RoleIconProps) => {
  const roleIcons = Object.values(PARTICIPANT_DISPLAY_ROLES).filter(
    item => item !== PARTICIPANT_DISPLAY_ROLES.PARTICIPANT,
  );

  if (!roleIcons.includes(role)) return null;
  return (
    <TippyV2 placement="top" content={t(`live_roles.${role}`)}>
      <Icon type={role} size={16} className="-mt-1 ml-1" />
    </TippyV2>
  );
};
